import React from 'react';
import { useTranslation } from 'react-i18next';

const Fallback = props => {
  const { t } = useTranslation();

  const { hideRefresh = false } = props;

  const styles = {
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      padding: '32px',
      minHeight: '100vh',
      width: '100%',
      fontFamily: 'Roboto, Arial, sans-serif',
    },
    title: {
      fontSize: '24px',
      fontWeight: '500',
      color: '#f44336',
      marginBottom: '16px',
      textAlign: 'center',
    },
    description: {
      fontSize: '16px',
      color: '#666',
      marginBottom: '32px',
      textAlign: 'center',
      maxWidth: '400px',
    },
    button: {
      padding: '12px 24px',
      backgroundColor: '#5336FF',
      color: 'white',
      border: 'none',
      borderRadius: '4px',
      fontSize: '14px',
      fontWeight: '500',
      cursor: 'pointer',
      textTransform: 'uppercase',
    },
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>{t('something_went_wrong')}</h2>
      <p style={styles.description}>
        {t('please_try_refreshing_the_page_or_contact')}
      </p>
      {!hideRefresh && (
        <button
          style={styles.button}
          onClick={() => window.location.reload(false)}
        >
          {t('refresh_page')}
        </button>
      )}
    </div>
  );
};

export default Fallback;
